export default __webpack_public_path__ + "static/media/elevate-blk-banner-2.1a2ffa6e.jpg";